import React, {Component} from 'react';
import {NavLink, withRouter} from "react-router-dom";
import Header from './dashboard/header/Header'
import '../../assets/sass/pages/home.scss'

import bars from '../../assets/svg/dashboard/sidebar/bars.svg';
import {ReactComponent as Dashboard} from '../../assets/svg/dashboard/sidebar/dashboard.svg';
import {ReactComponent as Matches_events} from '../../assets/svg/dashboard/sidebar/matches_events.svg';
import {ReactComponent as Messages} from '../../assets/svg/dashboard/sidebar/messages.svg';
import {ReactComponent as Scouting} from '../../assets/svg/dashboard/sidebar/scouting.svg';
import {ReactComponent as Talent_search} from '../../assets/svg/dashboard/sidebar/talent_search.svg';
import {ReactComponent as Watchlist} from '../../assets/svg/dashboard/sidebar/watchlist.svg';
import {connect} from "react-redux";
import {appUniqueKey, asideRightOpen, asideCollapse, routeHasChanged} from "../../store/actions/GlobalActions";
import Tools from "../../Tools";
import ThemeProvider from './ThemeProvider';
import {isFilterCleared} from "../../store/actions/Dashboard/TalentSearch/TalentSearchActions";

const classNames = require('classnames');

class DashbordLayout extends Component {

    state = {
        pageName: '',
        route_change: false,
        theme: ''
    }

    /**
     * Calculate & Update state of new dimensions
     */
    updateDimensions = (e) => {
        if (window.innerWidth < 1350) {
            this.props.asideCollapse(true);
        }
    }

    /**
     * Add event listener
     */
    componentDidMount() {
        // set global unique key state
        this.props.appUniqueKey(this.props.unique ?? '');

        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }

    /**
     * Remove event listener
     */
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteHasChanged();
        } else {
            setTimeout(() => {
                this.props.routeHasChanged(false);
            }, 0.1)
        }
    }

    onRouteHasChanged() {
        this.props.routeHasChanged(true);
        this.props.appUniqueKey(this.props.unique ?? '');
        this.openAside();
    }

    changeSidebarStatus = (e) => {

        e.preventDefault();

        switch (e.target.tagName.toLowerCase()) {
            case 'span': {
                this.props.history.push('/dashboard')
            }
                ;
                break;
            case 'img': {
                this.props.asideCollapse(!this.props.aside_collapse);
            }
                ;
                break;
        }
    }

    setTitle = (title) => {
        return this.props.aside_collapse ? title : null;
    }

    asideRight = () => {
        const AsideComponent = this.props.aside;
        if (this.props.aside) {
            return (
                <aside className="aside-right-container">
                    <AsideComponent openAside={this.openAside}/>
                </aside>
            )
        }

        return null;
    }

    openAside = () => {
        this.props.asideRightOpen(false);
    }

    appClassName = () => {
        // const talentSearchFilterCleared = this.props.isFilterCleared();

        const classes = classNames(
            "app-wrapper",
            this.props.aside_collapse ? "aside-collapse" : "",
            this.props.aside_right_open ? "aside-right-open" : "",
            this.props.route_has_changed ? "route-has-changed" : "",
        );

        console.log(classes);

        return classes;
    }

    handleThemeChange = theme => {
        this.setState({theme});
    }

    render() {
        return (
            <ThemeProvider theme={this.state.theme}>
                <div id={this.props.id} className={this.appClassName()}>
                    <aside className={["aside-container", this.props.aside_collapse ? "aside-mini" : "aside-full"].join(' ')}>
                        <nav>
                            <ul className="menu">
                                <li className="logo">
                                    <a href="#" onClick={this.changeSidebarStatus} title={this.setTitle("Scout Afrique")}>
                                        <img src={bars} className="img-svg-icon primary" alt="Scout Afrique"/>
                                        <span>Scout Afrique</span>
                                    </a>
                                </li>
                            </ul>
                            <ul className="menu">
                                <li className="menu-item">
                                    <NavLink to="/dashboard" title={this.setTitle("Dashbord")}>
                                        <div className="wrap-link">
                                            <Dashboard/>
                                            <span>Dashbord</span>
                                        </div>
                                    </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink to="/talent-search" title={this.setTitle("Talent Search")}>
                                        <div className="wrap-link">
                                            <Talent_search/>
                                            <span>Talent Search</span>
                                        </div>
                                    </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink to="/matches-and-events" title={this.setTitle("Matches & Events")}>
                                        <div className="wrap-link">
                                            <Matches_events/>
                                            <span>Matches & Events</span>
                                        </div>
                                    </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink to="/watchlist" title={this.setTitle("Watchlist")}>
                                        <div className="wrap-link">
                                            <Watchlist/>
                                            <span>Watchlist</span>
                                        </div>
                                    </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink to="/scouting" title={this.setTitle("Scouting")}>
                                        <div className="wrap-link">
                                            <Scouting/>
                                            <span>Scouting</span>
                                        </div>
                                    </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink to="/messages" title={this.setTitle("Messages")}>
                                        <div className="wrap-link">
                                            <Messages/>
                                            <span>Messages</span>
                                        </div>
                                    </NavLink>
                                </li>
                            </ul>
                        </nav>
                    </aside>
                    <section className="container-fluid section-container">
                        <Header title={this.props.title} header={this.props.header} onThemeChange={this.handleThemeChange}/>
                        <main className="main-wrapper">
                            {this.props.children}
                        </main>
                    </section>
                    {this.asideRight()}
                </div>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        aside_collapse: state.global.aside_collapse,
        aside_right_open: state.global.aside_right_open,
        route_has_changed: state.global.route_has_changed,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        appUniqueKey: (key) => dispatch(appUniqueKey(key)),
        asideCollapse: (toggle) => dispatch(asideCollapse(toggle)),
        asideRightOpen: (isOpen) => dispatch(asideRightOpen(isOpen)),
        routeHasChanged: (status) => dispatch(routeHasChanged(status)),
        isFilterCleared: () => dispatch(isFilterCleared()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashbordLayout));
